import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-all-employee-log',
  templateUrl: './all-employee-log.component.html',
  styleUrls: ['./all-employee-log.component.scss']
})
export class AllEmployeeLogComponent implements OnInit, OnDestroy {
  employeeLogData: any = []
  toshowData:boolean =true
  loader: boolean = false
  _apisub: Subscription
  pageNo: number = 1
  constructor(private navservice:NavigationService,private _apiservice:ApiService, private loaderservice: LoaderServiceService) {this.navservice.hideSidebarAndNav=false
    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_TODAYS_EMPLOYEE_LOG_FOR_DASHBOARD){
        this.employeeLogData = []
        if(resdata.result){
          resdata.result.forEach((element:any) => {
            if(element.entry_type == 1){
              element.entry_status = "In"
            }
            else if(element.entry_type == 0){
              element.entry_status = 'Out'
            }
            element.duty_time2 = this.formatToAmPm(element.duty_time)
            element.employee_phone = element.country_code + " " + element.phone
            this.employeeLogData.push(element)
          });

        }
        this.loaderservice.showLoader = false
        this.loader = false
        }
    })
   }
  ngOnInit(): void {
    this.loader = true
    this.loaderservice.showLoader = true
    this._apiservice.getTodaysEmployeeLogForDashboard('500',this.pageNo)
  }  
  bookingData = [
    { image: 'https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg', name: 'Rahul raj Rathod', phone: '+91 8989835354', shop: 'Mithali Hair, Spa, Balanced Beauty',  location: 'Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --', starus:'In' },
    { image: 'https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg', name: 'Suraj Paul', phone: '+91 8989835354', shop: 'Evonie Hair Salon & Makeup Studio',  location: '2nd floor, Raj sammilonee MAX mall, Bhiringi, Benachity, Durgapur, West Bengal 713213', time: '10:30 PM - -- -- --',  starus:'Out' },
    { image: 'https://media.istockphoto.com/id/1136413215/photo/young-man-at-street-market.jpg?s=612x612&w=0&k=20&c=obnaR5III0jRxHKd4ZPl3LRC2pI792KbHYR2eBzKKe8=', name: 'Sourav Das', phone: '+91 8989835354', shop: 'Invogue Salon Spa & NailBar',  location: '2nd Floor, Kamdhenu, Bengal Shrishti, above HDFC Bank, Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --',  starus:'Out' },
    { image: 'https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/8f706226-0b67-41ea-b84e-a7add4ea0658/fadf9214-bad0-41cb-8318-272d81dfe466.png', name: 'Rahul raj Rathod', phone: '+91 8989835354', shop: 'Mithali Hair, Spa, Balanced Beauty',  location: 'Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --',  starus:'Out' },
    { image: 'https://www.shutterstock.com/image-photo/cheerful-black-man-wearing-leather-600nw-2238222273.jpg', name: 'Rahul raj Rathod', phone: '+91 8989835354', shop: 'Mithali Hair, Spa, Balanced Beauty',  location: 'Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --',  starus:'Out' },
    { image: 'https://media.istockphoto.com/id/613557584/photo/portrait-of-a-beautifull-smiling-man.jpg?s=612x612&w=0&k=20&c=hkCg5CrmTKOApePbPOyo1U9GexEfIJOJqoLXJIvcN8E=', name: 'Rahul raj Rathod', phone: '+91 8989835354', shop: 'Mithali Hair, Spa, Balanced Beauty',  location: 'Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --',  starus:'Out' },
    { image: 'https://t4.ftcdn.net/jpg/02/70/84/61/360_F_270846119_LKNW0GcldOoicB0D4jKChIqClQl2Bd2N.jpg', name: 'Rahul raj Rathod', phone: '+91 8989835354', shop: 'Mithali Hair, Spa, Balanced Beauty',  location: 'Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --',  starus:'Out' },
    { image: 'https://t4.ftcdn.net/jpg/01/34/51/81/360_F_134518160_5DyP0y6YqXQgG6FdorIvpk7M6CBNrglm.jpg', name: 'Rahul raj Rathod', phone: '+91 8989835354', shop: 'Mithali Hair, Spa, Balanced Beauty',  location: 'Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --',  starus:'Out' },
    { image: 'https://images.rawpixel.com/image_800/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIzLTA4L3Jhd3BpeGVsX29mZmljZV8yX3Bob3RvX29mX2FfYmxhY2tfYnVzaW5lc3NtYW5faXNvbGF0ZWRfb25fb2ZmX19lZmMxZDllNC1iNzQ5LTQ2NzMtYjRmMS1lYjI0NTBiYzNiOGRfMS5qcGc.jpg', name: 'Rahul raj Rathod', phone: '+91 8989835354', shop: 'Mithali Hair, Spa, Balanced Beauty',  location: 'Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --',  starus:'Completed' },
    { image: 'https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg', name: 'Rahul raj Rathod', phone: '+91 8989835354', shop: 'Mithali Hair, Spa, Balanced Beauty',  location: 'Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216', time: '10:30 PM - -- -- --',  starus:'Out' },
  
  ];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "phone",
      columnProperty: "employee_phone"
    },
    {
      columnName: "shop",
      columnProperty: "business_name"
    },
    {
      columnName: "location",
      columnProperty: "address_line"
    },
    {
      columnName: "time",
      columnProperty: "duty_time2"
    },
  
    {
      columnName: "starus",
      columnProperty: "entry_status"
    }
  ];

  formatToAmPm(dateString: string): string {
  const timeMatch = dateString.match(/T(\d{2}):(\d{2})/);
  if (!timeMatch) return '';

  let hours = parseInt(timeMatch[1], 10);
  const minutes = parseInt(timeMatch[2], 10);

  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert 0 to 12
  const minutesStr = minutes < 10 ? '0' + minutes : minutes;

  return `${hours}:${minutesStr} ${ampm}`;
}


ngOnDestroy(): void {
  this._apisub.unsubscribe()
}
}
